/**
 * @file RecurringGroups.jsx
 * @location src/components/tasks/RecurringGroups.jsx
 * @role 루틴 카드 그리드 — 1줄 반복주기·2줄 루틴명·완료 도넛(현재 발생분). hover✎=편집 / 클릭=읽기상세.
 *   가동 정지·삭제는 읽기모달로 이관(인라인 버튼 제거).
 */
import { useApp } from '../../store/AppContext';
import { getTodayStr } from '../../data/constants';
import { recurrenceLabel, recurrenceFreqMark } from '../../utils/recurrenceLabels';
import { routineProgress } from '../../utils/routineProgress';
import { ProgressRing } from '../ui/ProgressRing';
import { EmptyState } from '../ui/SharedUI';
import { Icon } from '../ui/Icon';

export function RecurringGroups({ templates }) {
  const { S, act } = useApp();

  if (!templates.length) {
    return <div className="panel"><EmptyState icon="reset" title="아직 루틴 업무가 없습니다" desc="「루틴 추가」로 매일·매주·매월 할당을 자동화할 수 있습니다" /></div>;
  }

  const today = getTodayStr();
  const openRead = (id) => act('SET_UI', { patch: { modalRoutine: true, routineModalId: id, routineModalMode: 'read' } });
  const openEdit = (id, e) => { e.stopPropagation(); act('SET_UI', { patch: { modalRoutine: true, routineModalId: id, routineModalMode: 'edit' } }); };

  return (
    <div className="routine-card-grid">
      {templates.map(t => {
        const prog = routineProgress(t, S.tasks, today);
        const aeeCount = t.aees?.length ?? 0;
        const done = prog?.done ?? 0;
        // 미발생(prog=null)은 total=0 → 도넛 「—」. aeeCount 폴백은 「0/N 미완료」처럼 오해를 줌.
        const total = prog?.total ?? 0;
        const hasMembers = aeeCount > 0;
        return (
          <div key={t.id}
            className={`routine-card${t.active ? '' : ' paused'}`}
            role="button" tabIndex={0}
            onClick={() => openRead(t.id)}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openRead(t.id); } }}>
            <button type="button" className="routine-card-edit"
              aria-label="편집" title="편집" onClick={(e) => openEdit(t.id, e)}>
              <Icon name="edit" size={13} />
            </button>
            <div className="routine-card-meta">
              <span className="routine-card-freq">
                <span className="routine-card-freq-mark">{recurrenceFreqMark(t.repeat)}</span>
                <span className="routine-card-freq-label">{recurrenceLabel(t.repeat)}</span>
              </span>
              {!t.active && <span className="tag gray">정지 중</span>}
            </div>
            <div className="routine-card-title">{t.title}</div>
            <div className="routine-card-ring">
              <ProgressRing done={done} total={total} size={64} showText={false} />
            </div>
            <div className={`routine-card-count${hasMembers && prog ? '' : ' empty'}`}>
              {hasMembers ? (prog ? `${done} / ${total}` : '—') : '- / -'}
            </div>
          </div>
        );
      })}
    </div>
  );
}
